import { Organization } from "./organization";

export class SubGroup {
    subGroupID: number;
    subGroupName: string;
    divisionID: number;
    divisionName: string;
    communities: Organization[];
    hasUsers: boolean;
}
